// import { get } from "lodash";

export default {
  getFilterSets: (state) => state.filterSets.filterSets,
  getPreferredView: (state) => state.filterSets.preferredView,
};
